export default "<fusioncharts\r\nwidth=\"100%\"\r\ntype=\"Column2d\"\r\n[dataSource]=\"dataSource\"\r\n>\r\n</fusioncharts>\r\n"